(function () {
  'use strict';

  if (window.__nestMrcFeeAmountOnly20260709Loaded === 'v4-fast-line-event') return;
  window.__nestMrcFeeAmountOnly20260709Loaded = 'v4-fast-line-event';
  window.__nestMrcFeeAmountOnly20260709 = 'v4-fast-line-event';

  var feeVariantId = 39273096544337;
  var feeProductId = 6543483142225;
  var defaultFeeUnitCents = 1800;
  var eligibleProductIds = {4739110895697:1,4739110240337:1,4739111583825:1,4739109683281:1,4739109814353:1,4739110568017:1,7118596636753:1};
  var rootSelector = '.cart-modal,#CartDrawer,.cart-drawer,.drawer--cart,.ajax-cart,.ajaxcart,[data-cart-drawer],[data-cart-container]';
  var timer = null;
  var running = false;
  var pending = false;

  function clean(value) { return String(value || '').replace(/\u00a0/g, ' ').replace(/\s+/g, ' ').trim(); }
  function money(cents) { var d = (Math.max(0, Math.round(cents || 0)) / 100).toFixed(2).split('.'); d[0] = d[0].replace(/\B(?=(\d{3})+(?!\d))/g, ','); return '$' + d.join('.'); }
  function text(element) { return clean(element && element.textContent || ''); }
  function textOf(item) { return [item && item.product_title, item && item.title, item && item.handle, item && item.url, item && item.product_type, item && item.vendor].join(' ').toLowerCase(); }
  function propsOf(item) { return item && item.properties && typeof item.properties === 'object' ? item.properties : {}; }
  function visible(element) {
    var s, r;
    if (!element || !document.documentElement.contains(element)) return false;
    if (element.hasAttribute('hidden') || element.getAttribute('aria-hidden') === 'true') return false;
    s = getComputedStyle(element);
    r = element.getBoundingClientRect();
    return s.display !== 'none' && s.visibility !== 'hidden' && s.opacity !== '0' && r.width > 0 && r.height > 0;
  }
  function isMrcFee(item) {
    var props = propsOf(item);
    var value = textOf(item);
    return Number(item && item.variant_id) === feeVariantId || Number(item && item.product_id) === feeProductId || String(props.type || '').toLowerCase() === 'fee' || value.indexOf('mrc recycling fee') > -1 || value.indexOf('mattress recycling fee') > -1;
  }
  function isCompanion(item) {
    var value = textOf(item);
    return isMrcFee(item) || value.indexOf('lifetime renewal exchange') > -1 || value.indexOf('extend protection') > -1 || value.indexOf('protection plan') > -1;
  }
  function eligibleQty(cart) {
    return (cart && cart.items || []).reduce(function (sum, item) {
      return sum + (!item || isCompanion(item) || !eligibleProductIds[Number(item.product_id)] ? 0 : Number(item.quantity || 0));
    }, 0);
  }
  function mrcItems(cart) { return (cart && cart.items || []).filter(isMrcFee); }
  function mrcRawCents(cart) { return mrcItems(cart).reduce(function (sum, item) { return sum + Number(item.final_line_price || 0); }, 0); }
  function mrcUnitCents(cart) {
    var first = mrcItems(cart).filter(function (item) { return Number(item.quantity || 0) > 0; })[0];
    var unit = first ? Number(first.final_price || first.price || 0) : 0;
    return unit > 0 ? unit : defaultFeeUnitCents;
  }
  function displayCents(cart) {
    var raw = mrcRawCents(cart);
    var expected = eligibleQty(cart);
    if (raw > 0) return raw;
    if (expected > 0) return expected * mrcUnitCents(cart);
    return 0;
  }
  function forbidden(value) { return /\b(TOTAL|Subtotal|Taxes|Total Savings)\b/i.test(String(value || '').replace(/MRC\s*Fee:?/i, '')); }
  function moneyText(value) { return /\$[0-9,]+(?:\.\d{2})?/.test(String(value || '')); }
  function roots() {
    var list = Array.prototype.slice.call(document.querySelectorAll(rootSelector)).filter(function (root) { return visible(root) || /cart|drawer|ajaxcart/i.test(root.className || root.id || ''); });
    list = list.filter(function (root) { return !list.some(function (other) { return other !== root && other.contains(root); }); });
    return list.length ? list : [document.body];
  }
  function textNodes(root, pattern) {
    var nodes = [];
    var walker;
    if (!root || !document.createTreeWalker) return nodes;
    walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, { acceptNode: function (node) { return pattern.test(clean(node.nodeValue || '')) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT; } });
    while (walker.nextNode()) nodes.push(walker.currentNode);
    return nodes;
  }
  function moneyTextNodes(root) { return textNodes(root, /\$[0-9,]+(?:\.\d{2})?/); }
  function labels(root) {
    var found = [];
    textNodes(root, /\bMRC\s*Fee:?\b/i).forEach(function (node) {
      var element = node.parentElement;
      if (element && found.indexOf(element) === -1) found.push(element);
    });
    return found;
  }
  function setMoneyInElement(element, value) {
    var nodes;
    if (!element || forbidden(text(element))) return false;
    nodes = moneyTextNodes(element);
    if (nodes.length) {
      nodes[nodes.length - 1].nodeValue = String(nodes[nodes.length - 1].nodeValue || '').replace(/\$[0-9,]+(?:\.\d{2})?/, value);
      if (nodes[nodes.length - 1].parentElement) nodes[nodes.length - 1].parentElement.setAttribute('data-nest-mrc-fee-amount-only', 'true');
      return true;
    }
    if (text(element) === '' || /^[-–—]?$/.test(text(element))) {
      element.textContent = value;
      element.setAttribute('data-nest-mrc-fee-amount-only', 'true');
      return true;
    }
    return false;
  }
  function directSiblingTarget(label, value) {
    var node = label;
    var next;
    for (var depth = 0; node && depth < 4; depth += 1, node = node.parentElement) {
      next = node.nextElementSibling;
      if (next && !/MRC\s*Fee/i.test(text(next)) && !forbidden(text(next)) && (moneyText(text(next)) || text(next) === '' || /^[-–—]?$/.test(text(next)))) return setMoneyInElement(next, value) ? (node.parentElement || node) : null;
    }
    return null;
  }
  function sameRowTarget(label, value) {
    var row = label.parentElement;
    var children, index, next;
    for (var depth = 0; row && depth < 5; depth += 1, row = row.parentElement) {
      if (!/\bMRC\s*Fee:?\b/i.test(text(row)) || forbidden(text(row))) return null;
      children = Array.prototype.slice.call(row.children || []);
      index = children.findIndex(function (child) { return child === label || child.contains(label); });
      if (index === -1) continue;
      next = children[index + 1];
      if (next && !forbidden(text(next)) && setMoneyInElement(next, value)) return row;
      if (text(row).length <= 180 && moneyTextNodes(row).length && setMoneyInElement(row, value)) return row;
    }
    return null;
  }
  function updateRows(cents) {
    var value = money(cents);
    var updated = 0;
    var inspected = 0;
    var seen = [];
    roots().forEach(function (root) {
      labels(root).forEach(function (label) {
        var row;
        inspected += 1;
        row = directSiblingTarget(label, value) || sameRowTarget(label, value);
        if (!row || seen.indexOf(row) !== -1 || forbidden(text(row))) return;
        seen.push(row);
        row.setAttribute('data-nest-mrc-fee-amount-only-row', 'true');
        updated += 1;
      });
    });
    window.__nestMrcFeeAmountOnlyLastApply = { at: Date.now(), cents: cents, text: value, rows: updated, inspected: inspected };
  }
  function run() {
    if (!window.fetch) return;
    if (running) { pending = true; return; }
    running = true;
    pending = false;
    window.fetch('/cart.js?mrc_raw=1&mrc_amount_only=4&t=' + Date.now(), { headers: { Accept: 'application/json' }, cache: 'no-store', credentials: 'same-origin' })
      .then(function (response) { return response.json(); })
      .then(function (cart) {
        var cents = displayCents(cart);
        window.__nestMrcFeeAmountOnlyLastState = { at: Date.now(), expectedQty: eligibleQty(cart), rawMrcCents: mrcRawCents(cart), displayCents: cents, mrcLineCount: mrcItems(cart).length };
        updateRows(cents);
      })
      .catch(function (error) { window.__nestMrcFeeAmountOnlyLastError = error && error.message ? error.message : String(error); })
      .finally(function () { running = false; if (pending) schedule(0); });
  }
  function schedule(delay) { clearTimeout(timer); timer = setTimeout(run, typeof delay === 'number' ? delay : 140); }
  function fastRun(reason) {
    window.__nestMrcFeeAmountOnlyLastEvent = { at: Date.now(), reason: reason || 'event' };
    schedule(0);
    setTimeout(run, 90);
    setTimeout(run, 260);
  }
  function bind() {
    schedule(0);
    [180, 650, 1400, 2600].forEach(function (delay) { setTimeout(run, delay); });
    document.addEventListener('click', function () { schedule(140); }, true);
    document.addEventListener('change', function () { schedule(140); }, true);
    ['refreshAjaxCart', 'refreshCart', 'cart:refresh'].forEach(function (eventName) {
      window.addEventListener(eventName, function () { schedule(140); }, true);
      document.addEventListener(eventName, function () { schedule(140); }, true);
    });
    window.addEventListener('nest:mrc-fee-line-resynced', function () { fastRun('line-resynced window'); }, true);
    document.addEventListener('nest:mrc-fee-line-resynced', function () { fastRun('line-resynced document'); }, true);
    if (window.MutationObserver) new MutationObserver(function () { schedule(280); }).observe(document.documentElement, { childList: true, subtree: true, characterData: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bind, { once: true });
  else bind();
})();